import React from 'react';
import { Card, Title } from '@tremor/react';
import { IonButtons, IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonItem, IonLabel, IonList, IonModal, IonRow, IonSelect, IonSelectOption, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { OCCUPANT_TYPE } from '../../../utils/constants';

const SelectReportFilters = ({
  options,
  properties,
  statementType,
  propertyId,
  propertyIds,
  tenant,
  tenantOptions,
  loadingTenants,
  startDate,
  endDate,
  startMoMDate,
  endMoMDate,
  startYearOnYearDate,
  endYearOnYearDate,
  selectedColumns,
  showArchivedTenants,
  showNonPropertyExpenses,
  columnsModalOpen,
  tmpSelectedColumns,
  filterErrors,
  allPropertyIds,
  onSelectAllProperties,
  collapseDate,
  collapseMoM,
  collapseYoY,
  onChangeStatement,
  onSelectProperty,
  onTenantChange,
  setColumnsModalOpen,
  setTmpSelectedColumns,
  setSelectedColumns,
  setShowArchivedTenants,
  setShowNonPropertyExpenses,
  setCollapseDate,
  setCollapseMoM,
  setCollapseYoY,
  setStartDate,
  setEndDate,
  setStartMoMDate,
  setEndMoMDate,
  setStartYoYDate,
  setEndYoYDate,
}) => (
  <Card className="full-width-card">
    <Title>Step 2: Filters</Title>
    <div>
      <IonGrid>
        <IonRow>
          {statementType === 'Tenant Statement'
            ? <IonCol size="12"><h5>Select {options.userAccountType === OCCUPANT_TYPE ? 'Tenant' : 'Member'}</h5></IonCol>
            : <IonCol size="12"><h5>{statementType === 'Property Statement' ? 'Select Properties' : 'Select Property'}</h5></IonCol>}
        </IonRow>
        <IonRow>
          <IonCol size="12"><hr className="reports-divider" /></IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="12" sizeMd="6">
            <IonItem>
              <IonSelect
                label={statementType === 'Property Statement' ? 'Properties' : 'Property'}
                labelPlacement="stacked"
                multiple={statementType === 'Property Statement'}
                value={statementType === 'Property Statement' ? propertyIds : propertyId}
                onIonChange={onSelectProperty}
              >
                {Object.values(properties || {}).map((p) => (
                  <IonSelectOption key={p.propertyId} value={p.propertyId}>{p.propertyName}</IonSelectOption>
                ))}
              </IonSelect>
            </IonItem>
          </IonCol>
          {statementType === 'Property Statement' && (
            <IonCol size="12" sizeMd="6">
              <IonItem lines="none">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <IonCheckbox
                    aria-label="Select all properties"
                    checked={(propertyIds || []).length > 0 && (propertyIds || []).length === (allPropertyIds || []).length}
                    onIonChange={onSelectAllProperties}
                  />
                  <IonLabel>Select all properties</IonLabel>
                </div>
              </IonItem>
            </IonCol>
          )}
          {statementType === 'Tenant Statement' && (
            <IonCol size="12" sizeMd="6">
              <IonItem>
                <IonSelect disabled={loadingTenants} label={options.userAccountType === OCCUPANT_TYPE ? 'Tenant' : 'Member'} labelPlacement="stacked" value={tenant?.[0]?.id || ''} onIonChange={onTenantChange}>
                  {loadingTenants ? (
                    <IonSelectOption value="" disabled>Loading {options.userAccountType === OCCUPANT_TYPE ? 'tenants' : 'members'}...</IonSelectOption>
                  ) : tenantOptions.map((t) => (
                    <IonSelectOption key={t.id} value={t.id}>{t.label}</IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>
            </IonCol>
          )}
          {statementType === 'Deleted Tenants Report' && (
            <IonCol size="12" sizeMd="6">
              <IonItem>
                <IonSelect
                  multiple
                  disabled={loadingTenants || !propertyId}
                  label={`Search Deleted ${options.userAccountType === OCCUPANT_TYPE ? 'Tenant' : 'Member'}s (optional)`}
                  labelPlacement="stacked"
                  value={(tenant || []).map(({ id }) => id)}
                  onIonChange={onTenantChange}
                >
                  {!propertyId ? (
                    <IonSelectOption value="" disabled>Please select a property first</IonSelectOption>
                  ) : loadingTenants ? (
                    <IonSelectOption value="" disabled>Loading deleted {options.userAccountType === OCCUPANT_TYPE ? 'tenants' : 'members'}...</IonSelectOption>
                  ) : tenantOptions.map((t) => (
                    <IonSelectOption key={t.id} value={t.id}>{t.label}</IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>
            </IonCol>
          )}
        </IonRow>
        {statementType !== 'Tenant Statement' && statementType !== 'Deleted Tenants Report' && (
          <IonRow>
            <IonCol size="12"><hr className="reports-divider" /></IonCol>
          </IonRow>
        )}
        {(statementType === 'Tenant Statement' || statementType === 'Deleted Tenants Report') && (
          <IonRow>
            <IonCol size="12"><hr className="reports-divider" /></IonCol>
          </IonRow>
        )}

        {(statementType === 'Property Statement' || statementType === 'Arrears Report' || statementType === 'Expenses Report') && (
          <>
            <IonRow>
              <IonCol size="12"><h5>Date Range</h5></IonCol>
            </IonRow>
            <IonRow style={{ textAlign: 'center' }}>
              <IonCol size="12" sizeMd="6">
                <h6 style={{ margin: '0.5rem 0' }}>Start Date</h6>
                <input
                  type="date"
                  id="reportsStartDate"
                  name="reportsStartDate"
                  value={startDate || ''}
                  onChange={(e) => setStartDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
              <IonCol size="12" sizeMd="6">
                <h6 style={{ margin: '0.5rem 0' }}>End Date</h6>
                <input
                  type="date"
                  id="reportsEndDate"
                  name="reportsEndDate"
                  value={endDate || ''}
                  min={startDate || undefined}
                  onChange={(e) => setEndDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
            </IonRow>
          </>
        )}

        {(statementType === 'Property Statement') && (
          <>
            <IonRow>
              <IonCol size="12"><hr className="reports-divider" /></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12"><h5>Columns</h5></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <IonItem button detail={true} onClick={() => setColumnsModalOpen(true)}>
                  <IonLabel>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>Select Columns (optional)</div>
                    <div style={{ fontSize: '0.85rem', opacity: 0.8 }}>
                      {((selectedColumns || []).length === (options.allReportColumns || []).length && (options.allReportColumns || []).length > 0)
                        ? `All columns selected (${(options.allReportColumns || []).length})`
                        : ((selectedColumns || []).length > 0
                          ? `Selected: ${(selectedColumns || []).slice(0, 5).join(', ')}${(selectedColumns || []).length > 5 ? ' +' + ((selectedColumns || []).length - 5) + ' more' : ''}`
                          : 'No columns selected')}
                    </div>
                  </IonLabel>
                </IonItem>

                <IonModal isOpen={columnsModalOpen} onDidDismiss={() => setColumnsModalOpen(false)}>
                  <IonHeader>
                    <IonToolbar>
                      <IonTitle>Select Columns</IonTitle>
                      <IonButtons slot="end">
                        <IonButton onClick={() => setColumnsModalOpen(false)}>Cancel</IonButton>
                        <IonButton onClick={() => { setSelectedColumns([...(tmpSelectedColumns || [])]); }}>{'Done'}</IonButton>
                      </IonButtons>
                    </IonToolbar>
                  </IonHeader>
                  <IonContent>
                    <IonList>
                      <IonItem>
                        <IonLabel style={{ marginRight: 8 }}>
                          {((tmpSelectedColumns || []).length === (options.allReportColumns || []).length && (options.allReportColumns || []).length > 0) ? 'Unselect All' : 'Select All'}
                        </IonLabel>
                        <IonCheckbox
                          slot="end"
                          aria-label={(tmpSelectedColumns || []).length === (options.allReportColumns || []).length ? 'Unselect All' : 'Select All'}
                          checked={(tmpSelectedColumns || []).length === (options.allReportColumns || []).length && (options.allReportColumns || []).length > 0}
                          onIonChange={() => {
                            const allCols = options.allReportColumns || [];
                            const isAll = (tmpSelectedColumns || []).length === allCols.length && allCols.length > 0;
                            setTmpSelectedColumns(isAll ? [] : [...allCols]);
                          }}
                        />
                      </IonItem>
                      {(options.allReportColumns || []).map((col, idx) => (
                        <IonItem key={idx}>
                          <IonLabel style={{ marginRight: 8 }}>{col}</IonLabel>
                          <IonCheckbox
                            slot="end"
                            aria-label={col}
                            checked={(tmpSelectedColumns || []).includes(col)}
                            onIonChange={(e) => {
                              const checked = !!e.detail.checked;
                              const current = new Set(tmpSelectedColumns || []);
                              if (checked) current.add(col); else current.delete(col);
                              setTmpSelectedColumns(Array.from(current));
                            }}
                          />
                        </IonItem>
                      ))}
                    </IonList>
                  </IonContent>
                </IonModal>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12"><hr className="reports-divider" /></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12"><h5>Options</h5></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12"><hr className="reports-divider" /></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12" sizeMd="6">
                <IonItem lines="none">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <IonCheckbox
                      aria-label={"Show Deleted " + (options.userAccountType === OCCUPANT_TYPE ? 'Tenants' : 'Members')}
                      checked={showArchivedTenants}
                      onIonChange={(e) => setShowArchivedTenants(!!e.detail.checked)}
                    />
                    <IonLabel>Show Deleted {options.userAccountType === OCCUPANT_TYPE ? 'Tenants' : 'Members'}</IonLabel>
                  </div>
                </IonItem>
              </IonCol>
              <IonCol size="12" sizeMd="6">
                <IonItem lines="none">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <IonCheckbox
                      aria-label="Show Expenses not linked to any property"
                      checked={showNonPropertyExpenses}
                      onIonChange={(e) => setShowNonPropertyExpenses(!!e.detail.checked)}
                    />
                    <IonLabel>Show Expenses not linked to any property</IonLabel>
                  </div>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12"><hr className="reports-divider" /></IonCol>
            </IonRow>
          </>
        )}

        {statementType === 'Month on Month Report' && (
          <>
            <IonRow>
              <IonCol size="12"><h5>Month on Month Range</h5></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12" sizeMd="6">
                <h6>Start Month/Year</h6>
                <input
                  type="month"
                  id="reportsStartMonth"
                  name="reportsStartMonth"
                  value={startMoMDate || ''}
                  onChange={(e) => setStartMoMDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
              <IonCol size="12" sizeMd="6">
                <h6>End Month/Year</h6>
                <input
                  type="month"
                  id="reportsEndMonth"
                  name="reportsEndMonth"
                  value={endMoMDate || ''}
                  min={startMoMDate || undefined}
                  onChange={(e) => setEndMoMDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
            </IonRow>
          </>
        )}

        {statementType === 'Year on Year Report' && (
          <>
            <IonRow>
              <IonCol size="12"><h5>Year on Year Range</h5></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12" sizeMd="6">
                <h6>Start Year</h6>
                <input
                  type="number"
                  id="reportsStartYear"
                  name="reportsStartYear"
                  value={startYearOnYearDate || ''}
                  min="1900"
                  max="2100"
                  onChange={(e) => setStartYoYDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
              <IonCol size="12" sizeMd="6">
                <h6>End Year</h6>
                <input
                  type="number"
                  id="reportsEndYear"
                  name="reportsEndYear"
                  value={endYearOnYearDate || ''}
                  min={startYearOnYearDate || undefined}
                  max="2100"
                  onChange={(e) => setEndYoYDate(e.target.value || '')}
                  style={{ width: '100%', textAlign: 'center', padding: '8px', border: '2px solid gray' }}
                />
              </IonCol>
            </IonRow>
          </>
        )}

      </IonGrid>
      {filterErrors.length > 0 && (
        <IonRow>
          <IonCol size="12">
            <IonText color="danger">
              {filterErrors.join(' • ')}
            </IonText>
          </IonCol>
        </IonRow>
      )}
    </div>
  </Card>
);

export default SelectReportFilters;


